define( [
	"./arr"
], function( arr ) {
	return arr.concat;
} );



/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/jquery/src/var/concat.js
 ** module id = 818
 ** module chunks = 2
 **/